import React, {useRef} from 'react';
import Portal from '../../portal';
import {AnimatePresence, motion} from 'framer-motion';
import useOnClickOutside from '../../../utilities/hooks/useOutsideClick';
interface ModalProps {
  isOpen: boolean;
  children: React.ReactNode;

  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}
const Modal = ({isOpen, children, setIsOpen}: ModalProps) => {
  const wrapperRef = useRef(null);

  useOnClickOutside(wrapperRef, () => setIsOpen(false));

  return (
    <Portal>
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{y: 0, opacity: 0}}
            animate={{y: 0, opacity: 1}}
            exit={{y: 0, opacity: 0}}
            className="fixed top-0 bottom-0 left-0 right-0 z-50 flex items-center justify-center w-full h-full max-h-full overflow-x-hidden overflow-y-auto bg-gray-1000 md:inset-0"
          >
            <div className="relative flex items-center justify-center w-full max-w-2xl max-h-full p-4">
              <div
                className="relative bg-white shadow rounded-3xl dark:bg-gray-700"
                ref={wrapperRef}
              >
                {children}
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </Portal>
  );
};

export default Modal;
